import { useState } from 'react';
import { Input } from '@/components/ui/input.js';
import { Button } from '@/components/ui/button.js';
import { SchedulesList } from './SchedulesList.js';
import { CreateScheduleModal } from '@/components/scheduler/CreateScheduleModal.js';
import { Search, Plus } from 'lucide-react';
import { useSchedulerStore } from '@/stores/schedulerStore.js';

interface SchedulesPanelProps {
    onViewDetails?: (scheduleId: string) => void;
    hideHeader?: boolean;
}

export function SchedulesPanel({ onViewDetails, hideHeader }: SchedulesPanelProps) {
    const [searchQuery, setSearchQuery] = useState('');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const runningCount = useSchedulerStore((state) => state.getRunningCount());

    return (
        <div className="flex flex-col h-full">
            {/* Header - can be hidden when used in mobile view */}
            {!hideHeader && (
                <div className="p-4 border-b border-border/50">
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-lg font-semibold">Routines</h2>
                        <div className="flex items-center gap-2">
                            {runningCount > 0 && (
                                <span className="text-xs text-yellow-600 dark:text-yellow-500 animate-pulse">
                                    {runningCount} running
                                </span>
                            )}
                            <Button
                                size="sm"
                                onClick={() => setShowCreateModal(true)}
                                className="h-7 text-xs gap-1"
                            >
                                <Plus className="h-3.5 w-3.5" />
                                New
                            </Button>
                        </div>
                    </div>

                    {/* Search */}
                    <div className="relative">
                        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            placeholder="Search routines..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="pl-9 h-9"
                        />
                    </div>
                </div>
            )}

            {/* List */}
            <div className="flex-1 overflow-hidden">
                <SchedulesList
                    searchQuery={searchQuery}
                    onViewDetails={onViewDetails}
                />
            </div>

            {/* Create Modal */}
            {showCreateModal && (
                <CreateScheduleModal onClose={() => setShowCreateModal(false)} />
            )}
        </div>
    );
}
